/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Module for database management using Dexie

Author: Deimos Space UK

Version: 1.0
*/

import Dexie from 'dexie';

const db = new Dexie('MISEdatabase');
db.version(1).stores({
  files: '++id, name, data, orbit, phaseNumber, phaseName, pmd',
});

export default db;